// Страница-благодарность /pages/reklamation-eingegangen — Vorgangsnummer
// приходит через query (?rk=...&status=retry), Liquid не имеет доступа к
// query string, поэтому читаем и подставляем на клиенте.
function initReklamationEingegangen(root) {
	const block = root.querySelector('[data-reklamation-eingegangen]');
	if (!block) return;

	const params = new URLSearchParams(window.location.search);
	const rk = params.get('rk');
	const status = params.get('status');

	const okEl = block.querySelector('[data-reklamation-eingegangen-ok]');
	const retryEl = block.querySelector('[data-reklamation-eingegangen-retry]');
	const missingEl = block.querySelector('[data-reklamation-eingegangen-missing]');
	const detailsEl = block.querySelector('[data-reklamation-eingegangen-details]');
	const referenceEl = block.querySelector('[data-reklamation-eingegangen-reference]');

	if (!rk) {
		// Прямой заход на страницу без Vorgangsnummer (не из формы) — не показываем
		// текст успеха/повтора, только пояснение.
		if (okEl) okEl.hidden = true;
		if (retryEl) retryEl.hidden = true;
		if (detailsEl) detailsEl.hidden = true;
		if (missingEl) missingEl.hidden = false;
		return;
	}

	if (referenceEl) referenceEl.textContent = rk;
	if (detailsEl) detailsEl.hidden = false;

	if (status === 'retry') {
		if (okEl) okEl.hidden = true;
		if (retryEl) retryEl.hidden = false;
	}

	block.focus();
}

document.querySelectorAll('.reklamation-form').forEach(initReklamationEingegangen);
